import { render, staticRenderFns } from "./WideCareerData.vue?vue&type=template&id=24f144e8&scoped=true&"
import script from "./WideCareerData.vue?vue&type=script&lang=js&"
export * from "./WideCareerData.vue?vue&type=script&lang=js&"
import style0 from "./WideCareerData.vue?vue&type=style&index=0&id=24f144e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f144e8",
  null
  
)

export default component.exports